import { Injectable, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    constructor(private toastr: ToastrService, private zone: NgZone) {}

    success(
        message: string,
        title = 'Success',
        showProgressBar: boolean = false,
        timeout: number = 3000
    ) {
        this.zone.run(async () => {
            this.toastr.success(message, title, {
                timeOut: timeout,
                progressBar: showProgressBar
            });
        });
    }

    warning(
        message: string,
        title: string = 'Warning',
        showProgressBar: boolean = false,
        timeout: number = 3000
    ) {
        this.zone.run(async () => {
            this.toastr.warning(message, title, {
                timeOut: timeout,
                progressBar: showProgressBar
            });
        });
    }

    error(message: string, title = 'Error') {
        this.zone.run(async () => {
            this.toastr.error(message, title);
        });
    }
}
